import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, throwError } from "rxjs";
import { switchMap } from "rxjs/operators";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.url.includes('/login')) {
        return authService.handleLoginDialog(router.url, undefined, { origin: 'forced' }).pipe(
          switchMap((success) => {
            if (success) {
              return next(req);
            } else {
              authService.clearUserData();
              router.navigate(['/']);
              return throwError(() => error);
            }
          })
        );
      }
      return throwError(() => error);
    })
  );
};
